import { getStatusConfig } from "~/components/command-center/statusConfig";
import { cn } from "~/lib/utils";

export interface TaskStatusGlyphProps {
  readonly status: string;
  readonly className?: string;
}

/** Quiet in-row status circle matching group / board status semantics. */
export function TaskStatusGlyph({ status, className }: TaskStatusGlyphProps) {
  const config = getStatusConfig(status);
  return (
    <span
      role="img"
      aria-label={`Status: ${config.label}`}
      title={config.label}
      className={cn(
        "inline-flex size-3 shrink-0 rounded-full border-2",
        config.circleClass,
        className,
      )}
    />
  );
}
